import { render, staticRenderFns } from "./GeneralPopup.vue?vue&type=template&id=e6a0a766&scoped=true&"
import script from "./GeneralPopup.vue?vue&type=script&lang=ts&"
export * from "./GeneralPopup.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralPopup.vue?vue&type=style&index=0&id=e6a0a766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a0a766",
  null
  
)

export default component.exports